import { CalendarRange } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { PRESETS, presetRange, periodLabel } from "../lib/format";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { BasisToggle } from "./kit";

export default function PeriodBar({ hideBasis }) {
  const { range, setRange, settings, basis, setBasis } = useAuth();
  if (!range) return null;
  const pick = (p) => setRange(p === "custom" ? { ...range, preset: "custom" } : { preset: p, ...presetRange(p, settings.effective_date) });
  const setDay = (k, v) => {
    if (!v) return;
    const r = { ...range, preset: "custom", [k]: v };
    if (r.start > r.end) r[k === "start" ? "end" : "start"] = v;
    setRange(r);
  };
  return (
    <div className="bs-card p-4 mb-6 flex flex-col lg:flex-row lg:items-center gap-3" data-testid="period-bar">
      <div className="flex items-center gap-3 min-w-0">
        <CalendarRange className="w-5 h-5 text-[#C5A059] shrink-0" />
        <div className="min-w-0">
          <div className="bs-eyebrow">Selected period</div>
          <div className="font-display text-lg sm:text-xl font-bold text-[#011E38] truncate" data-testid="selected-period">{periodLabel(range)}</div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 lg:ml-auto">
        <Select value={range.preset} onValueChange={pick}>
          <SelectTrigger className="w-36 h-10" data-testid="period-preset-select"><SelectValue /></SelectTrigger>
          <SelectContent>{PRESETS.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`period-preset-${v}`}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <input type="date" value={range.start} onChange={(e) => setDay("start", e.target.value)} data-testid="period-start-input"
          className="h-10 rounded-md border border-slate-200 px-2 text-sm w-[9.5rem]" />
        <span className="text-slate-400">→</span>
        <input type="date" value={range.end} onChange={(e) => setDay("end", e.target.value)} data-testid="period-end-input"
          className="h-10 rounded-md border border-slate-200 px-2 text-sm w-[9.5rem]" />
        {!hideBasis && <BasisToggle basis={basis} setBasis={setBasis} />}
      </div>
    </div>
  );
}
